import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/ESPThermalPowerPlantsHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-24.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .etp { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .etp-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden; 
  }
  .etp-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .etp-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .etp-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .etp-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 520px;
  }
  .etp-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .etp-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .etp-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .etp-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .etp-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .etp-bc-item:hover { color: #EB2019; }
  .etp-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .etp-bc-sep img { width: 24px; height: 24px; display: block; }
  .etp-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .etp-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .etp-main-section { padding: 80px 0 120px 0; }
  .etp-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .etp-article { flex: 1; min-width: 0; }

  .etp-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .etp-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .etp-meta-item:last-child { border-right: none; padding-right: 0; }
  .etp-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .etp-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .etp-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .etp-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .etp-article-body p { margin-bottom: 20px; }
  .etp-article-body p:last-child { margin-bottom: 0; }

  .etp-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 5px 0 15px 0; line-height: 160%; display: block;
  }

  /* Numbered ol list */
  .etp-article-body ol {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
    counter-reset: etp-counter;
  }
  .etp-article-body ol li {
    display: flex; align-items: flex-start; gap: 8px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; counter-increment: etp-counter;
  }
  .etp-article-body ol li::before {
    content: counter(etp-counter) '.';
    font-weight: 400; color: #202020;
    flex-shrink: 0; min-width: 20px;
  }
  .etp-article-body ol li > span { flex: 1; }

  /* Bullet ul list */
  .etp-article-body ul {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .etp-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .etp-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .etp-article-body ul li > span { flex: 1; }

  .etp-article-body strong { font-weight: 600; color: #202020; }

  .etp-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .etp-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .etp-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .etp-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .etp-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .etp-nav-btn:hover { color: #EB2019; }
  .etp-nav-btn img { width: 40px; height: 40px; display: block; }

  .etp-share-icons { display: flex; align-items: center; gap: 20px; }
  .etp-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .etp-share-icon:hover { opacity: 0.85; }
  .etp-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .etp-sidebar { flex: 0 0 475px; }
  .etp-sidebar-block { margin-bottom: 60px; }
  .etp-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .etp-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .etp-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .etp-recent-item:hover .etp-recent-title { color: #EB2019; }
  .etp-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .etp-recent-body { flex: 1; min-width: 0; }
  .etp-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .etp-social-icons { display: flex; align-items: center; gap: 30px; }
  .etp-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .etp-social-icon:hover { opacity: 0.8; }
  .etp-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .etp-hero             { height: 350px; }
    .etp-hero-content     { padding: 0 32px; }
    .etp-hero-title       { font-size: 30px; }
    .etp-hero-divider     { width: 100%; max-width: 479px; }
    .etp-breadcrumb       { padding: 24px 0 0 0; }
    .etp-breadcrumb-inner { padding: 0 32px; }
    .etp-inner            { padding: 0 32px; }
    .etp-main-section     { padding: 48px 0 60px 0; }
    .etp-main-row         { flex-direction: column; gap: 48px; }
    .etp-sidebar          { flex: none; width: 100%; }
    .etp-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .etp-hero             { height: 360px; }
    .etp-hero-content     { padding: 0 16px; }
    .etp-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .etp-hero-divider     { width: 100%; }
    .etp-hero-subtitle    { font-size: 14px; }
    .etp-breadcrumb       { padding: 30px 0 0 0; }
    .etp-breadcrumb-inner { padding: 0 16px; }
    .etp-bc-item          { font-size: 14px; gap: 14px; }
    .etp-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .etp-bc-sep img       { width: 22px; height: 22px; }
    .etp-inner            { padding: 0 16px; }
    .etp-main-section     { padding: 30px 0 60px 0; }
    .etp-main-row         { flex-direction: column; gap: 60px; }
    .etp-sidebar          { flex: none; width: 100%; }
    .etp-article-title    { font-size: 20px; margin-bottom: 15px; }
    .etp-article-body     { font-size: 14px; }
    .etp-article-body p   { margin-bottom: 15px; }
    .etp-article-body ul  { margin: 0 0 20px 0; gap: 10px; }
    .etp-article-body ol  { margin: 0 0 20px 0; gap: 10px; }
    .etp-article-body ul li { font-size: 14px; }
    .etp-article-body ol li { font-size: 14px; }
    .etp-meta-item        { font-size: 14px; }
    .etp-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .etp-h2               { font-size: 16px; margin: 30px 0 15px 0; }
    .etp-nav-btn img      { width: 24px; height: 24px; }
    .etp-nav-btn          { font-size: 14px; }
    .etp-share-icon img   { width: 34px; height: 34px; }
    .etp-sidebar-title    { font-size: 20px; }
  }
`;

const recentPosts = [
   {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function ESPThermalPowerPlantsEfficiency() {
  return (
    <div className="etp">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="etp-hero">
        <img className="etp-hero-bg" src={HeroBgImg} alt="ESP Thermal Power Plants Hero" />
        <div className="etp-hero-overlay" />
        <div className="etp-hero-content">
          <h1 className="etp-hero-title">
            The Role of Electrostatic Precipitators in Thermal Power Plants: How They Improve Efficiency
          </h1>
          <hr className="etp-hero-divider" />
          <p className="etp-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="etp-breadcrumb" aria-label="Breadcrumb">
        <div className="etp-breadcrumb-inner">
          <a href="/" className="etp-bc-item">Home</a>
          <span className="etp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="etp-bc-item">News &amp; Updates</a>
          <span className="etp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="etp-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="etp-main-section">
        <div className="etp-inner">
          <div className="etp-main-row">

            {/* ── ARTICLE ── */}
            <article className="etp-article">

              {/* Meta bar */}
              <div className="etp-meta-bar">
                <span className="etp-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="etp-meta-item"><img src={CalendarIcon} alt="date" /> March 5, 2025</span>
                <span className="etp-meta-item"><img src={ClockIconImg} alt="time" /> 11:07 am</span>
                <span className="etp-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="etp-article-title">
                The Role of Electrostatic Precipitators in Thermal Power Plants: How They Improve Efficiency
              </h1>

              {/* Body */}
              <div className="etp-article-body">

                <p>The high quantities of electricity produced by thermal power plants also generate impurities in fine particles, soot, and fly ash. To the rescue comes <a href="understanding-electrostatic-precipitators" className="etp-red-link">electrostatic precipitators</a>. They help in minimizing air pollutants and optimizing efficiency. These devices suck in unhealthy particles from exhaust gases before they are emitted into the environment.</p>

                {/* Article image */}
                <img className="etp-article-img" src={ArticleImg} alt="Electrostatic Precipitators Thermal Power Plants" />

                <p>Let us dive into the nuances of electrostatic precipitators.</p>

                <p>How they work, contribute to thermal power plants, and contrast to other means of pollution mitigation?</p>

                <span className="etp-h2">The electrostatic precipitators</span>

                <p>An electrostatic precipitator is an equipment used to purify industrial exhaust gases of tiny particles, such as dust and ash. It collects and traps particles through an electrostatic charge, leading to cleaner power plant emissions.</p>

                <p>By removing over 99% of pollutants, ESPs ensure thermal power plants can run efficiently while minimizing environmental impact.</p>

                <span className="etp-h2">How Do Electrostatic Precipitators Work?</span>

                <p>The steps in this process of electrostatic precipitation are pretty straightforward.</p>

                <ol>
                  <li><span>The high-voltage electrode creates an electric field, which charges ash and dust particles in the flue gas.</span></li>
                  <li><span>Collection of particles: The particles of opposite charge travel towards opposite metal plates (collecting electrodes).</span></li>
                  <li><span>Dust removal – Dust is periodically shaken into a hopper to facilitate safe removal.</span></li>
                  <li><span>Release of clean air – Clean air is released into the environment, significantly reducing emissions.</span></li>
                </ol>

                <p>The process ensures that thermal energy-based power plants minimize air pollution while achieving high efficiency.</p>

                <span className="etp-h2">The Key Advantages of Electrostatic Precipitators in Power Plants</span>

                <ul>
                  <li><span><strong>Improves Air Quality –</strong> Removes over 99% of dust and ash, removing harmful emissions.</span></li>
                  <li><span><strong>Boosts Efficiency –</strong> Keeps boilers and turbines clean, minimizing deposits and ensuring they remain in proper working condition.</span></li>
                  <li><span><strong>Meets Environmental Standards –</strong> Helps ensure thermal power plants comply with strict air pollution regulations.</span></li>
                </ul>

                <p><strong>Low Cost of Operation:</strong> It is low in operational costs and is an economical solution to pollution.</p>

                <p><strong>Prolong Lifespan of Equipment:</strong> Does not permit fine particles to accumulate, which maintains equipment in better condition.</p>

                <span className="etp-h2">How Do Electrostatic Precipitators Compare to Other Control Methods?</span>

                <p>Other air pollution control technologies exist, but electrostatic precipitators are the most appropriate for power plants using heat. The following is how they measure up:</p>

                <ul>
                  <li><span><strong>Efficiency:</strong> ESPs can capture as much as 99% of fine particles, bag filters offer 90-99% efficiency and wet scrubbers capture 95-98% of contaminants.</span></li>
                  <li><span><strong>Operating Cost –</strong> The low operational costs of ESPs, compared to the moderate operational costs of bag filters and high operational costs of wet scrubbers due to the treatment of water,</span></li>
                  <li><span><strong>Maintenance—</strong>ESPs require little maintenance since they utilize electrostatic attraction, not physical filters. Physical filters, including bag filters, require periodic replacements, and wet scrubbers require ongoing maintenance because they treat water and have the potential for corrosion.</span></li>
                  <li><span><strong>Suitability for thermal power plants—</strong>large thermal power plants find ESPs suitable, as they can handle vast amounts of gas efficiently. Bag filters can clog in hot temperatures, and wet scrubbers remove gas but not particulate matter in dry form.</span></li>
                </ul>

                <span className="etp-h2">At a Glance</span>

                <p>Electrostatic precipitators are valuable to power plants that generate electricity thermally because they offer several benefits. They promote clean air, efficiency, and environmental compliance by eliminating pollutants, helping to create sustainable power and cleaner environments.</p>

                <p>As companies move towards cleaner energy, investing in <a href="understanding-electrostatic-precipitators" className="etp-red-link">electrostatic precipitators</a> is wise for power plants to reduce emissions while ensuring optimal performance.</p>

                <p>Do you require effective emission control systems? Contact us now!</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="etp-bottom-row">
                <div className="etp-bottom-nav">
                  <a href="/news/adorpowertron-smps-cuts-energy-consumption" className="etp-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/understanding-transformer-bushings-types-functions" className="etp-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="etp-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/the-role-of-electrostatic-precipitators-in-thermal-power-plants-how-they-improve-efficiency/" className="etp-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fthe-role-of-electrostatic-precipitators-in-thermal-power-plants-how-they-improve-efficiency%2F&mode=login" className="etp-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Fthe-role-of-electrostatic-precipitators-in-thermal-power-plants-how-they-improve-efficiency%2F%26title%3DElectrostatic%2520Precipitators%2520for%2520Power%2520Plants%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Fthe-role-of-electrostatic-precipitators-in-thermal-power-plants-how-they-improve-efficiency%2F" className="etp-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="etp-sidebar">

              {/* Recent Posts */}
              <div className="etp-sidebar-block">
                <p className="etp-sidebar-title">Recent Posts</p>
                <div className="etp-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="etp-recent-item">
                      <img src={post.img} alt={post.title} className="etp-recent-img" />
                      <div className="etp-recent-body">
                        <span className="etp-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="etp-sidebar-block">
                <p className="etp-sidebar-title">Social Media</p>
                <div className="etp-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="etp-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="etp-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}